module.exports = __webpack_public_path__ + "img/ctrl-p-stub-mid-0.304f58b4.svg";